import PropTypes from 'prop-types';
import React from 'react';

const propTypes = {
  to: PropTypes.string.isRequired,
  children: PropTypes.node
};

const LinkPhone = props => {
  const { to, children } = props;
  const args = Object.assign({}, props);
  delete args.children;
  delete args.to;
  return (
    <a {...args} href={`tel:${String(to).replace(/ /g, '')}`}>
      {children || to}
    </a>
  );
};

LinkPhone.propTypes = propTypes;

export default LinkPhone;
